import { createSelector } from '@reduxjs/toolkit';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { IShoppingCart } from './reducer';

interface IState {
  carts: IShoppingCart[];
}

export const ShoppingCartHook = () => {
  const shoppingCartState = (state: any) => state.ShoppingCart;

  const shoppingCartProperties = createSelector(shoppingCartState, (cart) => ({
    carts: cart.carts,
  }));

  const { carts } = useSelector(shoppingCartProperties);

  const [state, setState] = useState<IState>({
    carts,
  });

  useEffect(() => {
    setState({ carts });
  }, [carts]);

  return state;
};
